export const FORMS = {
    contactUs: "contact-us",
    vacancy: "vacancy",
};
